// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-product-analytics-dashboard {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 98%;
  margin: 0 auto 16px;
  overflow-x: hidden;
  overflow-y: visible;
  color: #17325c;
  font-family: "opensans", sans-serif;
}
.sales-product-analytics-dashboard .recharts-surface {
  direction: ltr;
}
.sales-product-analytics-dashboard__tabs {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  margin-bottom: 18px;
  border-radius: 18px;
  background: hsla(220, 10%, 46%, 0.08);
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__tab {
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: hsl(220, 10%, 46%);
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.15;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.sales-product-analytics-dashboard__tab:hover {
  background: rgba(255, 255, 255, 0.72);
  color: #17325c;
}
.sales-product-analytics-dashboard__tab--active {
  background: #ffffff;
  color: #17325c;
  box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);
}
.sales-product-analytics-dashboard__section {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.sales-product-analytics-dashboard__section .ant-spin-nested-loading, .sales-product-analytics-dashboard__section .ant-spin-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}
.sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__metric-card, .sales-product-analytics-dashboard__table-card {
  background: #ffffff;
  border: 1px solid hsla(220, 10%, 46%, 0.18);
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}
.sales-product-analytics-dashboard__overview-title {
  margin: 0;
  color: #101828;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.sales-product-analytics-dashboard__overview-subtitle {
  margin: 6px 0 0;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  line-height: 1.7;
}
.sales-product-analytics-dashboard__overview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 8;
  padding: 8px 0 14px;
  background: #ffffff;
  border-bottom: 1px solid rgba(23, 50, 92, 0.08);
}
.sales-product-analytics-dashboard__date-range {
  margin-left: auto;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__table-card {
  padding: 24px;
}
.sales-product-analytics-dashboard__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.sales-product-analytics-dashboard__metrics--overview {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  padding-bottom: 22px;
  margin-bottom: 20px;
}
.sales-product-analytics-dashboard__metric-card {
  padding: 14px 20px;
}
.sales-product-analytics-dashboard__metric-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.sales-product-analytics-dashboard__metric-label {
  margin: 0;
  color: hsl(220, 10%, 46%);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.sales-product-analytics-dashboard__metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background: hsla(220, 10%, 46%, 0.08);
  color: #3367d6;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__metric-icon-svg {
  width: 24px;
  height: 24px;
}
.sales-product-analytics-dashboard__metric-value {
  font-family: "opensans", sans-serif;
  color: #000000;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.sales-product-analytics-dashboard__metric-copy {
  margin: 8px 0 0;
  color: hsl(220, 10%, 46%);
  font-size: 13px;
  line-height: 1.6;
  font-weight: 500;
}
.sales-product-analytics-dashboard__metric-copy--positive {
  color: #198754;
}
.sales-product-analytics-dashboard__metric-copy--negative {
  color: #c33243;
}
.sales-product-analytics-dashboard__metric-copy-trend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sales-product-analytics-dashboard__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}
.sales-product-analytics-dashboard__grid--three {
  grid-template-columns: 1.15fr 0.85fr 0.85fr;
  min-width: 0;
}
.sales-product-analytics-dashboard__grid--three > * {
  min-width: 0;
}
.sales-product-analytics-dashboard__grid > *, .sales-product-analytics-dashboard__grid--three > * {
  align-self: start;
}
.sales-product-analytics-dashboard__card--full-span {
  grid-column: 1/-1;
}
.sales-product-analytics-dashboard__card-title {
  margin: 0 0 14px;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  font-family: "opensans", sans-serif;
}
.sales-product-analytics-dashboard__title-with-tooltip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__table-card .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__title-with-tooltip .sales-product-analytics-dashboard__card-title {
  margin-bottom: 0;
  line-height: 1.25;
}
.sales-product-analytics-dashboard__title-with-tooltip .definition-tooltip {
  margin-top: 0;
  flex-shrink: 0;
  align-self: center;
}
.sales-product-analytics-dashboard__card-subtitle {
  margin: 6px 0 14px;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  line-height: 1.6;
}
.sales-product-analytics-dashboard__chart-wrap {
  width: 100%;
  height: 280px;
  min-height: 280px;
  position: relative;
  overflow: visible;
}
.sales-product-analytics-dashboard__chart-wrap--sm {
  height: 220px;
  min-height: 220px;
}
.sales-product-analytics-dashboard__chart-wrap .recharts-responsive-container, .sales-product-analytics-dashboard__chart-wrap--sm .recharts-responsive-container {
  overflow: visible;
}
.sales-product-analytics-dashboard__chart-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 10px;
}
.sales-product-analytics-dashboard__chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}
.sales-product-analytics-dashboard__chart-legend-item--revenue {
  color: #3569db;
}
.sales-product-analytics-dashboard__chart-legend-item--expenses {
  color: #e0534d;
}
.sales-product-analytics-dashboard__chart-legend-item--profit {
  color: #2dbb5f;
}
.sales-product-analytics-dashboard__chart-legend-swatch {
  width: 10px;
  height: 10px;
  background: currentColor;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__summary-list, .sales-product-analytics-dashboard__legend-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.sales-product-analytics-dashboard__summary-row, .sales-product-analytics-dashboard__legend-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.sales-product-analytics-dashboard__summary-row span:first-child, .sales-product-analytics-dashboard__legend-row span:first-child {
  color: hsl(220, 10%, 46%);
}
.sales-product-analytics-dashboard__summary-row span:last-child, .sales-product-analytics-dashboard__legend-row span:last-child {
  color: #173f76;
  font-weight: 700;
}
.sales-product-analytics-dashboard__summary-value--positive {
  color: #16c05d !important;
}
.sales-product-analytics-dashboard__summary-value--negative {
  color: #ff3b30 !important;
}
.sales-product-analytics-dashboard__summary-value--warning {
  color: #ff9f0a !important;
}
.sales-product-analytics-dashboard__summary-value--muted {
  color: hsl(220, 10%, 46%) !important;
}
.sales-product-analytics-dashboard__legend-row--center {
  justify-content: center;
  gap: 24px;
}
.sales-product-analytics-dashboard__legend-row--breakdown {
  margin-top: -2px;
}
.sales-product-analytics-dashboard__legend-label {
  font-size: 14px;
  line-height: 1.4;
}
.sales-product-analytics-dashboard__legend-label--muted {
  color: hsl(220, 10%, 46%);
  font-weight: 500;
}
.sales-product-analytics-dashboard__legend-label--strong {
  color: #173f76;
  font-weight: 700;
}
.sales-product-analytics-dashboard__legend-value--plain {
  color: #173f76;
  font-weight: 700;
  min-width: 24px;
  text-align: right;
}
.sales-product-analytics-dashboard__legend-row--segmentation {
  margin-top: 4px;
  gap: 28px;
}
.sales-product-analytics-dashboard__legend-dot-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: hsl(220, 10%, 46%);
  font-size: 14px;
  font-weight: 500;
}
.sales-product-analytics-dashboard__legend-dot {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__filters--inline {
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__filters--stacked {
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  margin-bottom: 20px;
}
.sales-product-analytics-dashboard__search {
  min-width: 220px;
  flex: 1 1 220px;
}
.sales-product-analytics-dashboard__search--orders {
  min-width: 230px;
  flex: 0 0 230px;
}
.sales-product-analytics-dashboard__search--inventory {
  min-width: 260px;
  flex: 0 0 260px;
}
.sales-product-analytics-dashboard__search--customers {
  min-width: 260px;
  flex: 0 0 260px;
}
.sales-product-analytics-dashboard__select-menu {
  position: relative;
  min-width: 180px;
}
.sales-product-analytics-dashboard__select-menu--orders {
  min-width: 160px;
  width: 160px;
  flex: 0 0 160px;
}
.sales-product-analytics-dashboard__select-menu--inventory {
  min-width: 160px;
  width: 160px;
  flex: 0 0 160px;
}
.sales-product-analytics-dashboard__select-menu--sort {
  min-width: 220px;
  width: 220px;
  flex: 0 0 220px;
}
.sales-product-analytics-dashboard__select-menu--sort .sales-product-analytics-dashboard__select-trigger span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__select-menu--sort .sales-product-analytics-dashboard__select-dropdown {
  width: max-content;
  min-width: 100%;
  max-width: 280px;
}
.sales-product-analytics-dashboard__search--full, .sales-product-analytics-dashboard__select--full {
  width: 100%;
  min-width: 100%;
  flex: 0 0 auto;
}
.sales-product-analytics-dashboard__select--orders {
  width: 100%;
  min-width: 100%;
}
.sales-product-analytics-dashboard__select--inventory {
  width: 100%;
  min-width: 100%;
}
.sales-product-analytics-dashboard__search input, .sales-product-analytics-dashboard__select-trigger {
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid hsla(220, 10%, 46%, 0.18);
  border-radius: 8px;
  background: #ffffff;
  color: #17325c;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.sales-product-analytics-dashboard__search input:focus, .sales-product-analytics-dashboard__select-trigger:focus {
  border-color: #2c68ad;
  box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.12);
}
.sales-product-analytics-dashboard__select-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px 0 18px;
  cursor: pointer;
  text-align: left;
}
.sales-product-analytics-dashboard__select-trigger:hover {
  border-color: #c7d1df;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}
.sales-product-analytics-dashboard__select-trigger--open {
  border-color: #cfd8e3;
  box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);
}
.sales-product-analytics-dashboard__select-trigger-icon {
  width: 16px;
  height: 16px;
  color: #6b7280;
  flex-shrink: 0;
}
.sales-product-analytics-dashboard__select-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 20;
  width: 100%;
  min-width: 160px;
  max-height: 280px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #e6edf7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
.sales-product-analytics-dashboard__select-option {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__select-option:hover {
  background: #f2f2f2;
}
.sales-product-analytics-dashboard__select-option--active {
  background: #e4e4e4;
  color: #1f1f1f;
  font-weight: 600;
}
.sales-product-analytics-dashboard__select-option-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #111827;
}
.sales-product-analytics-dashboard__table-wrap {
  overflow-x: auto;
}
.sales-product-analytics-dashboard__table-card.dashboard-data-table-panel {
  width: 100%;
  min-width: 0;
  overflow: visible;
}
.sales-product-analytics-dashboard__table-card.dashboard-data-table-panel .dashboard-data-table-scroll {
  max-width: 100%;
}
.sales-product-analytics-dashboard__table.dashboard-data-table {
  font-family: "opensans", sans-serif;
}
.sales-product-analytics-dashboard__table.dashboard-data-table th.dashboard-data-table__number,
.sales-product-analytics-dashboard__table.dashboard-data-table td.dashboard-data-table__number {
  text-align: left !important;
}
.sales-product-analytics-dashboard__table.dashboard-data-table th.dashboard-data-table__number .dashboard-data-table__sort {
  justify-content: flex-start !important;
  width: auto;
}
.sales-product-analytics-dashboard__table-card--top-products {
  padding: 20px 0 0;
  min-width: 0;
}
.sales-product-analytics-dashboard__table-card--top-products .dashboard-data-table-panel__header {
  min-height: 0;
  padding: 26px 24px 26px;
  align-items: start;
  justify-content: flex-start;
}
.sales-product-analytics-dashboard__table-card--top-products .sales-product-analytics-dashboard__title-with-tooltip {
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__table-card--top-products .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
}
.sales-product-analytics-dashboard__table-card--top-products .dashboard-data-table-scroll {
  padding: 0 24px 20px;
}
.sales-product-analytics-dashboard__table-card--orders {
  padding: 22px 0 20px;
}
.sales-product-analytics-dashboard__table-card--inventory {
  padding: 22px 0 20px;
}
.sales-product-analytics-dashboard__table-card--customers {
  padding: 22px 0 20px;
}
.sales-product-analytics-dashboard__table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 24px;
  margin-bottom: 14px;
}
.sales-product-analytics-dashboard__panel-tools {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
  justify-content: flex-end;
}
.sales-product-analytics-dashboard__panel-tools .dashboard-data-table-panel__search {
  min-width: 0 !important;
  flex: 0 0 52%;
  width: 32%;
  max-width: 32%;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__card-title {
  padding: 0;
  margin-bottom: 0;
  font-size: 16px;
}
.sales-product-analytics-dashboard__table-card--orders .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table-card--inventory .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table-card--customers .sales-product-analytics-dashboard__table-wrap {
  padding-top: 0;
}
.sales-product-analytics-dashboard__table--overview th, .sales-product-analytics-dashboard__table--overview td {
  padding-left: 24px;
  padding-right: 24px;
}
.sales-product-analytics-dashboard__pill, .sales-product-analytics-dashboard__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}
.sales-product-analytics-dashboard__pill {
  min-width: 48px;
  padding: 7px 12px;
  background: #3569db;
  color: #ffffff;
}
.sales-product-analytics-dashboard__status--completed, .sales-product-analytics-dashboard__status--returning, .sales-product-analytics-dashboard__status--in_stock {
  background: #198754;
  color: #fff;
}
.sales-product-analytics-dashboard__status--pending, .sales-product-analytics-dashboard__status--new, .sales-product-analytics-dashboard__status--low_stock {
  background: #9a6a00;
  color: #fff;
}
.sales-product-analytics-dashboard__status--refunded, .sales-product-analytics-dashboard__status--cancelled, .sales-product-analytics-dashboard__status--out_of_stock {
  background: #c33243;
  color: #fff;
}
.sales-product-analytics-dashboard__source-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
.sales-product-analytics-dashboard__source-badge--zid {
  background: rgba(130, 201, 30, 0.12);
  border-color: rgba(130, 201, 30, 0.28);
  color: #5f7f1f;
}
.sales-product-analytics-dashboard__source-badge--odoo {
  background: rgba(152, 82, 125, 0.12);
  border-color: rgba(152, 82, 125, 0.28);
  color: #98527d;
}
.sales-product-analytics-dashboard__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 16px 20px 2px;
}
.sales-product-analytics-dashboard__pagination-copy {
  color: hsl(220, 10%, 46%);
  font-size: 14px;
}
.sales-product-analytics-dashboard__pagination-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.sales-product-analytics-dashboard__pagination-controls button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #94a3b8;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease;
}
.sales-product-analytics-dashboard__pagination-controls button:hover:not(:disabled) {
  background: hsla(220, 10%, 46%, 0.08);
}
.sales-product-analytics-dashboard__pagination-controls button:disabled {
  opacity: 0.45;
  color: #94a3b8;
  cursor: not-allowed;
}
.sales-product-analytics-dashboard__financial-bars {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.sales-product-analytics-dashboard__financial-bar-copy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  color: #17325c;
  font-size: 14px;
}
.sales-product-analytics-dashboard__financial-bar-track {
  height: 10px;
  border-radius: 999px;
  background: hsla(220, 10%, 46%, 0.08);
  overflow: hidden;
}
.sales-product-analytics-dashboard__financial-bar-fill {
  height: 100%;
  border-radius: 999px;
  background: #2c68ad;
}
.sales-product-analytics-dashboard__financial-bar-fill--negative {
  background: #d9534f;
}
@media (max-width: 1200px) {
  .sales-product-analytics-dashboard__metrics, .sales-product-analytics-dashboard__metrics--overview, .sales-product-analytics-dashboard__grid, .sales-product-analytics-dashboard__grid--three {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .sales-product-analytics-dashboard {
    width: 100%;
  }
  .sales-product-analytics-dashboard__tabs {
    padding: 6px;
    gap: 6px;
  }
  .sales-product-analytics-dashboard__tab {
    width: auto;
    text-align: left;
    padding: 12px 16px;
  }
  .sales-product-analytics-dashboard__card, .sales-product-analytics-dashboard__metric-card, .sales-product-analytics-dashboard__table-card {
    padding: 20px;
    border-radius: 18px;
  }
  .sales-product-analytics-dashboard__overview-title {
    font-size: 24px;
  }
  .sales-product-analytics-dashboard__overview-header {
    flex-direction: column;
    align-items: stretch;
  }
  .sales-product-analytics-dashboard__date-range {
    width: 100%;
    margin-left: 0;
  }
  .sales-product-analytics-dashboard__date-range .organic-range-picker {
    width: 100%;
  }
  .sales-product-analytics-dashboard__date-range .organic-range-picker__control {
    width: 100%;
  }
  .sales-product-analytics-dashboard__metric-value {
    font-size: 24px;
  }
  .sales-product-analytics-dashboard__pagination {
    flex-direction: column;
    align-items: flex-start;
  }
  .sales-product-analytics-dashboard__table-header {
    flex-direction: column;
    align-items: stretch;
    padding: 0 20px;
  }
  .sales-product-analytics-dashboard__filters--inline {
    flex-wrap: wrap;
    justify-content: stretch;
  }
  .sales-product-analytics-dashboard__search--orders, .sales-product-analytics-dashboard__search--inventory, .sales-product-analytics-dashboard__search--customers, .sales-product-analytics-dashboard__select-menu--orders, .sales-product-analytics-dashboard__select-menu--inventory, .sales-product-analytics-dashboard__select-menu--sort {
    width: 100%;
    min-width: auto;
  }
}

.sales-product-analytics-dashboard > *:not(.sales-product-analytics-dashboard__tabs) {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/omnichannelAnalytics/components/OmnichannelAnalyticsTabsDashboard.scss"],"names":[],"mappings":"AAMA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mCAAA;AALF;AAOE;EACE,cAAA;AALJ;AAQE;EACE,oBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAzB0B;EA0B1B,kBAAA;EACA,eAAA;EACA,cAAA;AANJ;AASE;EACE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBArC6B;EAsC7B,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uEAAA;AAPJ;AASI;EACE,qCAAA;EACA,cAAA;AAPN;AAWE;EACE,mBAAA;EACA,cAAA;EACA,8CAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAVJ;AAaE;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAZJ;AAeE;EAGE,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,4CAAA;AAfJ;AAkBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,yBA1F6B;EA2F7B,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,+CAAA;AAlBJ;AAqBE;EACE,iBAAA;EACA,cAAA;AAnBJ;AAsBE;EAEE,aAAA;AArBJ;AAwBE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAtBJ;AAyBE;EACE,gDAAA;EACA,oBAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,kBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAzBJ;AA4BE;EACE,SAAA;EACA,yBAhJ6B;EAiJ7B,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA1BJ;AA6BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCA5J0B;EA6J1B,cAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,YAAA;AA5BJ;AA+BE;EACE,mCAAA;EACD,cAAA;EACC,eAAA;EACA,gBAAA;EACA,gBAAA;AA7BJ;AAgCE;EACE,eAAA;EACA,yBAlL6B;EAmL7B,eAAA;EACA,gBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,cAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;AAmCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,2CAAA;EACA,YAAA;AAnCJ;AAsCE;EACE,YAAA;AApCJ;AAuCE;EAEE,iBAAA;AAtCJ;AAyCE;EACE,iBAAA;AAvCJ;AA0CE;EACA,gBAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAxCJ;AA2CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,iBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AA5CJ;AA+CE;EACE,kBAAA;EACA,yBA/P6B;EAgQ7B,eAAA;EACA,gBAAA;AA7CJ;AAgDE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,iBAAA;AA/CJ;AAkDE;EAEE,iBAAA;AAjDJ;AAoDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAlDJ;AAqDE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnDJ;AAsDE;EACE,cAAA;AApDJ;AAuDE;EACE,cAAA;AArDJ;AAwDE;EACE,cAAA;AAtDJ;AAyDE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;AAvDJ;AA0DE;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AAzDJ;AA4DE;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AA3DJ;AA8DE;EAEE,yBA5U6B;AA+QjC;AAgEE;EAEE,cAAA;EACA,gBAAA;AA/DJ;AAkEE;EACE,yBAAA;AAhEJ;AAmEE;EACE,yBAAA;AAjEJ;AAoEE;EACE,yBAAA;AAlEJ;AAqEE;EACE,oCAAA;AAnEJ;AAsEE;EACE,uBAAA;EACA,SAAA;AApEJ;AAuEE;EACE,gBAAA;AArEJ;AAwEE;EACE,eAAA;EACA,gBAAA;AAtEJ;AAyEE;EACE,yBApX6B;EAqX7B,gBAAA;AAvEJ;AA0EE;EACE,cAAA;EACA,gBAAA;AAxEJ;AA2EE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAzEJ;AA4EE;EACE,eAAA;EACA,SAAA;AA1EJ;AA6EE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBA7Y6B;EA8Y7B,eAAA;EACA,gBAAA;AA3EJ;AA8EE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AA5EJ;AA+EE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA7EJ;AAgFE;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;AA9EJ;AAiFE;EACE,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AA/EJ;AAkFE;EACE,gBAAA;EACA,eAAA;AAhFJ;AAmFE;EACE,gBAAA;EACA,eAAA;AAjFJ;AAoFE;EACE,gBAAA;EACA,eAAA;AAlFJ;AAqFE;EACE,gBAAA;EACA,eAAA;AAnFJ;AAsFE;EACE,kBAAA;EACA,gBAAA;AApFJ;AAuFE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AArFJ;AAwFE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAtFJ;AAyFE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AAvFJ;AAyFI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvFN;AA0FI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAxFN;AA4FE;EAEE,WAAA;EACA,eAAA;EACA,cAAA;AA3FJ;AA8FE;EACE,WAAA;EACA,eAAA;AA5FJ;AA+FE;EACE,WAAA;EACA,eAAA;AA7FJ;AAgGE;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AA/FJ;AAiGI;EACE,qBAAA;EACA,8CAAA;AA/FN;AAmGE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAjGJ;AAoGE;EACE,qBAAA;EACA,4CAAA;AAlGJ;AAqGE;EACE,qBAAA;EACA,+CAAA;AAnGJ;AAsGE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AApGJ;AAuGE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AArGJ;AAwGE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAtGJ;AAyGE;EACE,mBAAA;AAvGJ;AA0GE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAxGJ;AA2GE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzGJ;AA4GE;EACE,gBAAA;AA1GJ;AA6GE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA3GJ;AA8GE;EACE,eAAA;AA5GJ;AA+GE;EACE,mCAAA;AA7GJ;AA+GI;;EAEE,2BAAA;AA7GN;AAgHI;EACE,sCAAA;EACA,WAAA;AA9GN;AAkHE;EACE,iBAAA;EACA,YAAA;AAhHJ;AAmHE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;AAjHJ;AAoHE;EACE,gBAAA;AAlHJ;AAqHE;EACE,UAAA;EACA,gBAAA;AAnHJ;AAsHE;EACE,oBAAA;AApHJ;AAuHE;EACE,oBAAA;AArHJ;AAwHE;EACE,oBAAA;AAtHJ;AAyHE;EACE,oBAAA;AAvHJ;AA0HE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAxHJ;AA2HE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;AAzHJ;AA4HE;EACE,uBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;AA1HJ;AA6HE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AA3HJ;AA8HE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AA5HJ;AA+HE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AA7HJ;AAgIE;EACE,cAAA;AA9HJ;AAiIE;EACE,cAAA;AA/HJ;AAkIE;EACE,cAAA;AAhIJ;AAmIE;EAEE,kBAAA;EACA,mBAAA;AAlIJ;AAqIE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApIJ;AAuIE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AArIJ;AAwIE;EAGE,mBAAA;EACA,WAAA;AAxIJ;AA2IE;EAGE,mBAAA;EACA,WAAA;AA3IJ;AA8IE;EAGE,mBAAA;EACA,WAAA;AA9IJ;AAiJE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA/IJ;AAkJE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAhJJ;AAmJE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AAjJJ;AAoJE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAlJJ;AAqJE;EACE,yBAnyB6B;EAoyB7B,eAAA;AAnJJ;AAsJE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AApJJ;AAuJE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,6EAAA;AArJJ;AAwJE;EACE,qCA7zB0B;AAuqB9B;AAyJE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AAvJJ;AA0JE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxJJ;AA2JE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAzJJ;AA4JE;EACE,YAAA;EACA,oBAAA;EACA,qCAz1B0B;EA01B1B,gBAAA;AA1JJ;AA6JE;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;AA3JJ;AA8JE;EACE,mBAAA;AA5JJ;AA+JE;EACE;IAIE,0BAAA;EAhKJ;AACF;AAmKE;EA92BF;IA+2BI,WAAA;EAhKF;EAkKE;IACE,YAAA;IACA,QAAA;EAhKJ;EAmKE;IACE,WAAA;IACA,gBAAA;IACA,kBAAA;EAjKJ;EAoKE;IAGE,aAAA;IACA,mBAAA;EApKJ;EAuKE;IACE,eAAA;EArKJ;EAwKE;IACE,sBAAA;IACA,oBAAA;EAtKJ;EAyKE;IACE,WAAA;IACA,cAAA;EAvKJ;EA0KE;IACE,WAAA;EAxKJ;EA2KE;IACE,WAAA;EAzKJ;EA4KE;IACE,eAAA;EA1KJ;EA6KE;IACE,sBAAA;IACA,uBAAA;EA3KJ;EA8KE;IACE,sBAAA;IACA,oBAAA;IACA,eAAA;EA5KJ;EA+KE;IACE,eAAA;IACA,wBAAA;EA7KJ;EAgLE;IAME,WAAA;IACA,eAAA;EAnLJ;AACF;;AAwLA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AArLF","sourcesContent":["@import \"../../../styles/variables\";\n\n$sales-product-muted-foreground: hsl(220 10% 46%);\n$sales-product-muted-border: hsla(220, 10%, 46%, 0.18);\n$sales-product-muted-surface: hsla(220, 10%, 46%, 0.08);\n\n.sales-product-analytics-dashboard {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 98%;\n  margin: 0 auto 16px;\n  overflow-x: hidden;\n  overflow-y: visible;\n  color: #17325c;\n  font-family: \"opensans\", sans-serif;\n\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  &__tabs {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px;\n    margin-bottom: 18px;\n    border-radius: 18px;\n    background: $sales-product-muted-surface;\n    width: fit-content;\n    max-width: 100%;\n    flex-shrink: 0;\n  }\n\n  &__tab {\n    border: 0;\n    border-radius: 14px;\n    background: transparent;\n    color: $sales-product-muted-foreground;\n    padding: 14px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.15;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.72);\n      color: #17325c;\n    }\n  }\n\n  &__tab--active {\n    background: #ffffff;\n    color: #17325c;\n    box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  &__section .ant-spin-nested-loading,\n  &__section .ant-spin-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    min-width: 0;\n  }\n\n  &__card,\n  &__metric-card,\n  &__table-card {\n    background: #ffffff;\n    border: 1px solid $sales-product-muted-border;\n    border-radius: 8px;\n    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);\n  }\n\n  &__overview-title {\n    margin: 0;\n    color: #101828;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__overview-subtitle {\n    margin: 6px 0 0;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    line-height: 1.7;\n  }\n\n  &__overview-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n    position: sticky;\n    top: 0;\n    z-index: 8;\n    padding: 8px 0 14px;\n    background: #ffffff;\n    border-bottom: 1px solid rgba(23, 50, 92, 0.08);\n  }\n\n  &__date-range {\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  &__card,\n  &__table-card {\n    padding: 24px;\n  }\n\n  &__metrics {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 14px;\n  }\n\n  &__metrics--overview {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    padding-bottom: 22px;\n    margin-bottom: 20px;\n  }\n\n  &__metric-card {\n    padding: 14px 20px;\n  }\n\n  &__metric-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  &__metric-label {\n    margin: 0;\n    color: $sales-product-muted-foreground;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  &__metric-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 10px;\n    background: $sales-product-muted-surface;\n    color: #3367d6;\n    flex-shrink: 0;\n  }\n\n  &__metric-icon-svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  &__metric-value {\n    font-family: 'opensans', sans-serif;\n   color: #000000;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__metric-copy {\n    margin: 8px 0 0;\n    color: $sales-product-muted-foreground;\n    font-size: 13px;\n    line-height: 1.6;\n    font-weight: 500;\n  }\n\n  &__metric-copy--positive {\n    color: #198754;\n  }\n\n  &__metric-copy--negative {\n    color: #c33243;\n  }\n\n  &__metric-copy-trend {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 18px;\n    align-items: start;\n  }\n\n  &__grid--three {\n    grid-template-columns: 1.15fr 0.85fr 0.85fr;\n    min-width: 0;\n  }\n\n  &__grid--three > * {\n    min-width: 0;\n  }\n\n  &__grid > *,\n  &__grid--three > * {\n    align-self: start;\n  }\n\n  &__card--full-span {\n    grid-column: 1 / -1;\n  }\n\n  &__card-title {\n  margin: 0 0 14px;\n    color: #000000;\n    font-size: 14px;\n    font-weight: 700;\n    font-family: 'opensans', sans-serif;\n  }\n\n  &__title-with-tooltip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 14px;\n  }\n\n  &__table-card .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__title-with-tooltip &__card-title {\n    margin-bottom: 0;\n    line-height: 1.25;\n  }\n\n  &__title-with-tooltip .definition-tooltip {\n    margin-top: 0;\n    flex-shrink: 0;\n    align-self: center;\n  }\n\n  &__card-subtitle {\n    margin: 6px 0 14px;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    line-height: 1.6;\n  }\n\n  &__chart-wrap {\n    width: 100%;\n    height: 280px;\n    min-height: 280px;\n    position: relative;\n    overflow: visible;\n  }\n\n  &__chart-wrap--sm {\n    height: 220px;\n    min-height: 220px;\n  }\n\n  &__chart-wrap .recharts-responsive-container,\n  &__chart-wrap--sm .recharts-responsive-container {\n    overflow: visible;\n  }\n\n  &__chart-legend {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n    margin-top: 10px;\n  }\n\n  &__chart-legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1;\n  }\n\n  &__chart-legend-item--revenue {\n    color: #3569db;\n  }\n\n  &__chart-legend-item--expenses {\n    color: #e0534d;\n  }\n\n  &__chart-legend-item--profit {\n    color: #2dbb5f;\n  }\n\n  &__chart-legend-swatch {\n    width: 10px;\n    height: 10px;\n    background: currentColor;\n    flex-shrink: 0;\n  }\n\n  &__summary-list,\n  &__legend-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__summary-row,\n  &__legend-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 13px;\n  }\n\n  &__summary-row span:first-child,\n  &__legend-row span:first-child {\n    color: $sales-product-muted-foreground;\n  }\n\n  &__summary-row span:last-child,\n  &__legend-row span:last-child {\n    color: #173f76;\n    font-weight: 700;\n  }\n\n  &__summary-value--positive {\n    color: #16c05d !important;\n  }\n\n  &__summary-value--negative {\n    color: #ff3b30 !important;\n  }\n\n  &__summary-value--warning {\n    color: #ff9f0a !important;\n  }\n\n  &__summary-value--muted {\n    color: $sales-product-muted-foreground !important;\n  }\n\n  &__legend-row--center {\n    justify-content: center;\n    gap: 24px;\n  }\n\n  &__legend-row--breakdown {\n    margin-top: -2px;\n  }\n\n  &__legend-label {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n\n  &__legend-label--muted {\n    color: $sales-product-muted-foreground;\n    font-weight: 500;\n  }\n\n  &__legend-label--strong {\n    color: #173f76;\n    font-weight: 700;\n  }\n\n  &__legend-value--plain {\n    color: #173f76;\n    font-weight: 700;\n    min-width: 24px;\n    text-align: right;\n  }\n\n  &__legend-row--segmentation {\n    margin-top: 4px;\n    gap: 28px;\n  }\n\n  &__legend-dot-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  &__legend-dot {\n    width: 14px;\n    height: 14px;\n    border-radius: 999px;\n    flex-shrink: 0;\n  }\n\n  &__filters {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n  }\n\n  &__filters--inline {\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n    margin-bottom: 0;\n  }\n\n  &__filters--stacked {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    margin-bottom: 20px;\n  }\n\n  &__search {\n    min-width: 220px;\n    flex: 1 1 220px;\n  }\n\n  &__search--orders {\n    min-width: 230px;\n    flex: 0 0 230px;\n  }\n\n  &__search--inventory {\n    min-width: 260px;\n    flex: 0 0 260px;\n  }\n\n  &__search--customers {\n    min-width: 260px;\n    flex: 0 0 260px;\n  }\n\n  &__select-menu {\n    position: relative;\n    min-width: 180px;\n  }\n\n  &__select-menu--orders {\n    min-width: 160px;\n    width: 160px;\n    flex: 0 0 160px;\n  }\n\n  &__select-menu--inventory {\n    min-width: 160px;\n    width: 160px;\n    flex: 0 0 160px;\n  }\n\n  &__select-menu--sort {\n    min-width: 220px;\n    width: 220px;\n    flex: 0 0 220px;\n\n    .sales-product-analytics-dashboard__select-trigger span:first-child {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    .sales-product-analytics-dashboard__select-dropdown {\n      width: max-content;\n      min-width: 100%;\n      max-width: 280px;\n    }\n  }\n\n  &__search--full,\n  &__select--full {\n    width: 100%;\n    min-width: 100%;\n    flex: 0 0 auto;\n  }\n\n  &__select--orders {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  &__select--inventory {\n    width: 100%;\n    min-width: 100%;\n  }\n\n  &__search input,\n  &__select-trigger {\n    width: 100%;\n    height: 48px;\n    padding: 0 14px;\n    border: 1px solid $sales-product-muted-border;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #17325c;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n    &:focus {\n      border-color: #2c68ad;\n      box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.12);\n    }\n  }\n\n  &__select-trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 0 16px 0 18px;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  &__select-trigger:hover {\n    border-color: #c7d1df;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  }\n\n  &__select-trigger--open {\n    border-color: #cfd8e3;\n    box-shadow: 0 0 0 3px rgba(207, 216, 227, 0.18);\n  }\n\n  &__select-trigger-icon {\n    width: 16px;\n    height: 16px;\n    color: #6b7280;\n    flex-shrink: 0;\n  }\n\n  &__select-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    z-index: 20;\n    width: 100%;\n    min-width: 160px;\n    max-height: 280px;\n    overflow-y: auto;\n    padding: 6px;\n    border: 1px solid #e6edf7;\n    border-radius: 12px;\n    background: #ffffff;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\n  }\n\n  &__select-option {\n    display: grid;\n    grid-template-columns: 20px minmax(0, 1fr);\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    min-height: 40px;\n    padding: 10px 12px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: #0f172a;\n    font-size: 13px;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease;\n    white-space: nowrap;\n  }\n\n  &__select-option:hover {\n    background: #f2f2f2;\n  }\n\n  &__select-option--active {\n    background: #e4e4e4;\n    color: #1f1f1f;\n    font-weight: 600;\n  }\n\n  &__select-option-check {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    color: #111827;\n  }\n\n  &__table-wrap {\n    overflow-x: auto;\n  }\n\n  &__table-card.dashboard-data-table-panel {\n    width: 100%;\n    min-width: 0;\n    overflow: visible;\n  }\n\n  &__table-card.dashboard-data-table-panel .dashboard-data-table-scroll {\n    max-width: 100%;\n  }\n\n  &__table.dashboard-data-table {\n    font-family: 'opensans', sans-serif;\n\n    th.dashboard-data-table__number,\n    td.dashboard-data-table__number {\n      text-align: left !important;\n    }\n\n    th.dashboard-data-table__number .dashboard-data-table__sort {\n      justify-content: flex-start !important;\n      width: auto;\n    }\n  }\n\n  &__table-card--top-products {\n    padding: 20px 0 0;\n    min-width: 0;\n  }\n\n  &__table-card--top-products .dashboard-data-table-panel__header {\n    min-height: 0;\n    padding: 26px 24px 26px;\n    align-items: start;\n    justify-content: flex-start;\n  }\n\n  &__table-card--top-products .sales-product-analytics-dashboard__title-with-tooltip {\n    margin-bottom: 0;\n  }\n\n  &__table-card--top-products .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n  }\n\n  &__table-card--top-products .dashboard-data-table-scroll {\n    padding: 0 24px 20px;\n  }\n\n  &__table-card--orders {\n    padding: 22px 0 20px;\n  }\n\n  &__table-card--inventory {\n    padding: 22px 0 20px;\n  }\n\n  &__table-card--customers {\n    padding: 22px 0 20px;\n  }\n\n  &__table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 0 24px;\n    margin-bottom: 14px;\n  }\n\n  &__panel-tools {\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    min-width: 0;\n    justify-content: flex-end;\n  }\n\n  &__panel-tools .dashboard-data-table-panel__search {\n    min-width: 0 !important;\n    flex: 0 0 52%;\n    width: 32%;\n    max-width: 32%;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__table-card--inventory .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__card-title {\n    padding: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n  }\n\n  &__table-card--orders .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table-card--inventory .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table-card--customers .sales-product-analytics-dashboard__table-wrap {\n    padding-top: 0;\n  }\n\n  &__table--overview th,\n  &__table--overview td {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  &__pill,\n  &__status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__pill {\n    min-width: 48px;\n    padding: 7px 12px;\n    background: #3569db;\n    color: #ffffff;\n  }\n\n  &__status--completed,\n  &__status--returning,\n  &__status--in_stock {\n    background: #198754;\n    color: #fff;\n  }\n\n  &__status--pending,\n  &__status--new,\n  &__status--low_stock {\n    background: #9a6a00;\n    color: #fff;\n  }\n\n  &__status--refunded,\n  &__status--cancelled,\n  &__status--out_of_stock {\n    background: #c33243;\n    color: #fff;\n  }\n\n  &__source-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    border-radius: 999px;\n    border: 1px solid transparent;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &__source-badge--zid {\n    background: rgba(130, 201, 30, 0.12);\n    border-color: rgba(130, 201, 30, 0.28);\n    color: #5f7f1f;\n  }\n\n  &__source-badge--odoo {\n    background: rgba(152, 82, 125, 0.12);\n    border-color: rgba(152, 82, 125, 0.28);\n    color: #98527d;\n  }\n\n  &__pagination {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 16px;\n    padding: 16px 20px 2px;\n  }\n\n  &__pagination-copy {\n    color: $sales-product-muted-foreground;\n    font-size: 14px;\n  }\n\n  &__pagination-controls {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  &__pagination-controls button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border: 1px solid #94a3b8;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #1f2937;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    transition: opacity 0.16s ease, color 0.16s ease, background-color 0.16s ease;\n  }\n\n  &__pagination-controls button:hover:not(:disabled) {\n    background: $sales-product-muted-surface;\n  }\n\n  &__pagination-controls button:disabled {\n    opacity: 0.45;\n    color: #94a3b8;\n    cursor: not-allowed;\n  }\n\n  &__financial-bars {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  &__financial-bar-copy {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 6px;\n    color: #17325c;\n    font-size: 14px;\n  }\n\n  &__financial-bar-track {\n    height: 10px;\n    border-radius: 999px;\n    background: $sales-product-muted-surface;\n    overflow: hidden;\n  }\n\n  &__financial-bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: #2c68ad;\n  }\n\n  &__financial-bar-fill--negative {\n    background: #d9534f;\n  }\n\n  @media (max-width: 1200px) {\n    &__metrics,\n    &__metrics--overview,\n    &__grid,\n    &__grid--three {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n\n    &__tabs {\n      padding: 6px;\n      gap: 6px;\n    }\n\n    &__tab {\n      width: auto;\n      text-align: left;\n      padding: 12px 16px;\n    }\n\n    &__card,\n    &__metric-card,\n    &__table-card {\n      padding: 20px;\n      border-radius: 18px;\n    }\n\n    &__overview-title {\n      font-size: 24px;\n    }\n\n    &__overview-header {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__date-range {\n      width: 100%;\n      margin-left: 0;\n    }\n\n    &__date-range .organic-range-picker {\n      width: 100%;\n    }\n\n    &__date-range .organic-range-picker__control {\n      width: 100%;\n    }\n\n    &__metric-value {\n      font-size: 24px;\n    }\n\n    &__pagination {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    &__table-header {\n      flex-direction: column;\n      align-items: stretch;\n      padding: 0 20px;\n    }\n\n    &__filters--inline {\n      flex-wrap: wrap;\n      justify-content: stretch;\n    }\n\n    &__search--orders,\n    &__search--inventory,\n    &__search--customers,\n    &__select-menu--orders,\n    &__select-menu--inventory,\n    &__select-menu--sort {\n      width: 100%;\n      min-width: auto;\n      //flex: 1 1 100%;\n    }\n  }\n}\n\n.sales-product-analytics-dashboard > *:not(.sales-product-analytics-dashboard__tabs) {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
